<div class="main-container">
  <form [formGroup]="myActivationsDetailsForm" novalidate>
    <!-- Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title">My AIS140 Ticket Details</span>
      </div>
      <div class="button-group">
        <app-ticketing-info></app-ticketing-info>
      </div>
    </div>

    <!-- Ticket Information -->
    <div class="component-container">
      <!-- Component Header Section -->
      <div
        class="component-header"
        (click)="ticketInfoToggle()"
        tabindex="0"
        (keydown.enter)="ticketInfoToggle()"
      >
        <h6 class="component-title">Ticket Information</h6>
        <div class="component-actions">
          @if (!ticketInfoDrop) {
            <button type="button" class="primary-button" (click)="(0)">
              <mat-icon class="btn-icon">expand_more </mat-icon>
            </button>
          }
          @if (ticketInfoDrop) {
            <button type="button" class="primary-button" (click)="(0)">
              <mat-icon class="btn-icon">expand_less </mat-icon>
            </button>
          }
        </div>
      </div>
      @if (ticketInfoDrop) {
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <!-- Component Body Section -->
        <div class="component-body">
          <div class="form-section">
            <!-- Ticket Number -->
            <div class="form-group">
              <label for="ticketNo" class="form-label">Ticket Number</label>
              <mat-form-field appearance="outline">
                <mat-label>Ticket Number</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.ticketNo ? ticketDetails.ticketNo : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Ticket Handler -->
            <div class="form-group">
              <label for="firstName" class="form-label">Ticket Handler</label>
              @if (!this.MyActivationsUpdateMasterAccess) {
                <mat-form-field appearance="outline">
                  <mat-label>Ticket Handler</mat-label>
                  <input
                    matInput
                    readonly
                    type="text"
                    value="{{
                      ticketDetails.userData.length > 0
                        ? ticketDetails.userData[0].firstName +
                          ' ' +
                          ticketDetails.userData[0].lastName
                        : '--'
                    }}"
                  />
                </mat-form-field>
              }
              @if (this.MyActivationsUpdateMasterAccess) {
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label class="lable_style2">Ticket Handler</mat-label>
                  <mat-select #stateUserSelect formControlName="assignedTo">
                    <mat-option>
                      <ngx-mat-select-search
                        [formControl]="nameFilterCtrl"
                        [noEntriesFoundLabel]="'No options found'"
                        placeholderLabel="Filter"
                        (filteredReturn)="filteredStateUser = $any($event)"
                      >
                      </ngx-mat-select-search>
                    </mat-option>
                    @for (item of filteredStateUser; track item) {
                      <mat-option [value]="item._id">
                        {{ item.fullName }}
                      </mat-option>
                    }
                    @if (isAssigneeMissingFromList()) {
                      <mat-option [value]="ticketDetails.assignedTo" disabled>
                        {{ ticketDetails.userData[0].firstName }}
                        {{ ticketDetails.userData[0].lastName }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (
                    myActivationsDetailsForm.controls['assignedTo'].touched &&
                    myActivationsDetailsForm.controls['assignedTo'].errors
                      ?.required
                  ) {
                    <mat-error> This field is mandatory. </mat-error>
                  }
                </mat-form-field>
              }
            </div>
            <!-- Ticket Created On -->
            <div class="form-group">
              <label for="ticketStartDate" class="form-label"
                >Ticket Created On</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Ticket Created On</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.ticketStartDate
                      ? (ticketDetails.ticketStartDate
                        | date: 'dd MMM yyyy | hh:mm a')
                      : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Ticket Assigned On -->
            <div class="form-group">
              <label for="assignDate" class="form-label"
                >Ticket Assigned On</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Ticket Assigned On</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.assignDate
                      ? (ticketDetails.assignDate
                        | date: 'dd MMM yyyy | hh:mm a')
                      : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Ticket Cancelled or Completed On -->
            <div class="form-group">
              <label for="ticketEndDate" class="form-label"
                >Ticket Cancelled or Completed On</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Ticket Cancelled or Completed On</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.ticketEndDate
                      ? (ticketDetails.ticketEndDate
                        | date: 'dd MMM yyyy | hh:mm a')
                      : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Certificate Validity Duration -->
            <div class="form-group">
              <label for="certificateExpiry" class="form-label"
                >Certificate Validity Duration</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Certificate Validity Duration</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.certificateExpiry
                      ? ticketDetails.certificateExpiry + ' Years'
                      : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Overall Ticket Status -->
            <div class="form-group">
              <label for="remarkbyaccolade" class="form-label"
                >Overall Ticket Status</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Overall Ticket Status</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.remarkbyaccolade
                      ? simplifiedTicketStatus[ticketDetails.remarkbyaccolade]
                      : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Overall Ticket Remark -->
            <div class="form-group">
              <label for="remarkbyaccolade" class="form-label"
                >Overall Ticket Remark</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Overall Ticket Remark</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.overAllRemark
                      ? ticketDetails.overAllRemark
                      : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Ticket Generated By -->
            <div class="form-group">
              <label for="InstitutionalSales" class="form-label"
                >Ticket Generated By</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Ticket Generated By</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.InstitutionalSales &&
                    ticketDetails.InstitutionalSales === 'Y'
                      ? 'Institutional Sales'
                      : 'TML CRM & FE'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Ticket Description -->
            <div class="form-group">
              <label for="ticketDescription" class="form-label"
                >Ticket Description</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Ticket Description</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.ticketDescription
                      ? ticketDetails.ticketDescription
                      : '--'
                  }}"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Device Information -->
    <div class="component-container">
      <!-- Component Header Section -->
      <div
        class="component-header"
        (click)="deviceInfoToggle()"
        tabindex="0"
        (keydown.enter)="deviceInfoToggle()"
      >
        <h6 class="component-title">Device Information</h6>
        <div class="component-actions">
          @if (!deviceInfoDrop) {
            <button type="button" class="primary-button" (click)="(0)">
              <mat-icon class="btn-icon">expand_more </mat-icon>
            </button>
          }
          @if (deviceInfoDrop) {
            <button type="button" class="primary-button" (click)="(0)">
              <mat-icon class="btn-icon">expand_less </mat-icon>
            </button>
          }
        </div>
      </div>
      @if (deviceInfoDrop) {
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <!-- Component Body Section -->
        <div class="component-body">
          <div class="form-section">
            <!-- UIN Number -->
            <div class="form-group">
              <label for="uid" class="form-label">UIN Number</label>
              <mat-form-field appearance="outline">
                <mat-label>UIN Number</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{ ticketDetails.uid ? ticketDetails.uid : '--' }}"
                />
              </mat-form-field>
            </div>
            <!-- IMEI Number -->
            <div class="form-group">
              <label for="imei" class="form-label">IMEI Number</label>
              <mat-form-field appearance="outline">
                <mat-label>IMEI Number</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{ ticketDetails.imei ? ticketDetails.imei : '--' }}"
                />
              </mat-form-field>
            </div>
            <!-- ICCID Number -->
            <div class="form-group">
              <label for="iccid" class="form-label">ICCID Number</label>
              <mat-form-field appearance="outline">
                <mat-label>ICCID Number</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{ ticketDetails.iccid ? ticketDetails.iccid : '--' }}"
                />
              </mat-form-field>
            </div>
            <!-- Model Name -->
            <div class="form-group">
              <label for="modelname" class="form-label">Model Name</label>
              <mat-form-field appearance="outline">
                <mat-label>Model Name</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.modelname ? ticketDetails.modelname : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Device Make -->
            <div class="form-group">
              <label for="devicemake" class="form-label">Device Make</label>
              <mat-form-field appearance="outline">
                <mat-label>Device Make</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.devicemake ? ticketDetails.devicemake : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Primary Operator Name -->
            <div class="form-group">
              <label for="primaryOperator" class="form-label"
                >Primary Operator Name</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Primary Operator Name</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.primaryOperator
                      ? ticketDetails.primaryOperator
                      : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Primary Operator Number -->
            <div class="form-group">
              <label for="primaryMobNo" class="form-label"
                >Primary Operator Number</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Primary Operator Number</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.primaryMobNo
                      ? ticketDetails.primaryMobNo
                      : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Secondary Operator Name -->
            <div class="form-group">
              <label for="secondaryOperator" class="form-label"
                >Secondary Operator Name</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Secondary Operator Name</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.secondaryOperator
                      ? ticketDetails.secondaryOperator
                      : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Secondary Operator Number -->
            <div class="form-group">
              <label for="secondaryMobNo" class="form-label"
                >Secondary Operator Number</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Secondary Operator Number</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.secondaryMobNo
                      ? ticketDetails.secondaryMobNo
                      : '--'
                  }}"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Vehicle Owner Information -->
    <div class="component-container">
      <!-- Component Header Section -->
      <div
        class="component-header"
        (click)="ownerInfoToggle()"
        tabindex="0"
        (keydown.enter)="ownerInfoToggle()"
      >
        <h6 class="component-title">Vehicle Owner Information</h6>
        <div class="component-actions">
          @if (!ownerInfoDrop) {
            <button type="button" class="primary-button" (click)="(0)">
              <mat-icon class="btn-icon">expand_more </mat-icon>
            </button>
          }
          @if (ownerInfoDrop) {
            <button type="button" class="primary-button" (click)="(0)">
              <mat-icon class="btn-icon">expand_less </mat-icon>
            </button>
          }
        </div>
      </div>
      @if (ownerInfoDrop) {
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <!-- Component Body Section -->
        <div class="component-body">
          <div class="form-section">
            <!-- Vehicle Owner Name -->
            <div class="form-group">
              <label for="ownerfirstName" class="form-label"
                >Vehicle Owner Name</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Vehicle Owner Name</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    (ticketDetails.ownerfirstName
                      ? ticketDetails.ownerfirstName + ' '
                      : ' ') +
                      (ticketDetails.ownerMiddleName
                        ? ticketDetails.ownerMiddleName + ' '
                        : ' ') +
                      (ticketDetails.ownerLastName
                        ? ticketDetails.ownerLastName
                        : ' ')
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Mobile Number -->
            <div class="form-group">
              <label for="RMN" class="form-label">Mobile Number</label>
              <mat-form-field appearance="outline">
                <mat-label>Mobile Number</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails['RMN'] ? ticketDetails['RMN'] : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Alternate Mobile Number -->
            <div class="form-group">
              <label for="altRMN" class="form-label"
                >Alternate Mobile Number</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Alternate Mobile Number</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails['altRMN'] ? ticketDetails['altRMN'] : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Email -->
            <div class="form-group">
              <label for="ownerEmail" class="form-label">Email</label>
              <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails['ownerEmail']
                      ? ticketDetails['ownerEmail']
                      : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- POA Doc Type -->
            <div class="form-group">
              <label for="poaDocName" class="form-label">POA Doc Type</label>
              <mat-form-field appearance="outline">
                <mat-label>POA Doc Type</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.poaDocName ? ticketDetails.poaDocName : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- POA Doc No -->
            <div class="form-group">
              <label for="poaDocNo" class="form-label">POA Doc No</label>
              <mat-form-field appearance="outline">
                <mat-label>POA Doc No</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.poaDocNo ? ticketDetails.poaDocNo : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- POI Doc Type -->
            <div class="form-group">
              <label for="poiDoc" class="form-label">POI Doc Type</label>
              <mat-form-field appearance="outline">
                <mat-label>POI Doc Type</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.poiDoc ? ticketDetails.poiDoc : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- POI Doc No -->
            <div class="form-group">
              <label for="poiDocNo" class="form-label">POI Doc No</label>
              <mat-form-field appearance="outline">
                <mat-label>POI Doc No</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.poiDocNo ? ticketDetails.poiDocNo : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Address -->
            <div class="form-group">
              <label for="address" class="form-label">Address</label>
              <mat-form-field appearance="outline">
                <mat-label>Address</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{ ticketDetails.address }}"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Vehicle Information -->
    <div class="component-container">
      <!-- Component Header Section -->
      <div
        class="component-header"
        (click)="vehicleInfoToggle()"
        tabindex="0"
        (keydown.enter)="vehicleInfoToggle()"
      >
        <h6 class="component-title">Vehicle Information</h6>
        <div class="component-actions">
          @if (!vehicleInfoDrop) {
            <button type="button" class="primary-button" (click)="(0)">
              <mat-icon class="btn-icon">expand_more </mat-icon>
            </button>
          }
          @if (vehicleInfoDrop) {
            <button type="button" class="primary-button" (click)="(0)">
              <mat-icon class="btn-icon">expand_less </mat-icon>
            </button>
          }
        </div>
      </div>
      @if (vehicleInfoDrop) {
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <!-- Component Body Section -->
        <div class="component-body">
          <div class="form-section">
            <!-- Vehicle Model -->
            <div class="form-group">
              <label for="vehiclemodel" class="form-label">Vehicle Model</label>
              <mat-form-field appearance="outline">
                <mat-label>Vehicle Model</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.vehiclemodel
                      ? ticketDetails.vehiclemodel
                      : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Vehicle Make -->
            <div class="form-group">
              <label for="vehiclemake" class="form-label">Vehicle Make</label>
              <mat-form-field appearance="outline">
                <mat-label>Vehicle Make</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.vehiclemake ? ticketDetails.vehiclemake : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Manufacturing Year -->
            <div class="form-group">
              <label for="mfgyear" class="form-label">Manufacturing Year</label>
              <mat-form-field appearance="outline">
                <mat-label>Manufacturing Year</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.mfgyear ? ticketDetails.mfgyear : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Chassis Number -->
            <div class="form-group">
              <label for="vinNo" class="form-label">Chassis Number</label>
              <mat-form-field appearance="outline">
                <mat-label>Chassis Number</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{ ticketDetails.vinNo ? ticketDetails.vinNo : '--' }}"
                />
              </mat-form-field>
            </div>
            <!-- Engine Number -->
            <div class="form-group">
              <label for="enginenumber" class="form-label">Engine Number</label>
              <mat-form-field appearance="outline">
                <mat-label>Engine Number</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.enginenumber
                      ? ticketDetails.enginenumber
                      : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Registration Number -->
            <div class="form-group">
              <label for="regNo" class="form-label">Registration Number</label>
              <mat-form-field appearance="outline">
                <mat-label>Registration Number</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{ ticketDetails.regNo ? ticketDetails.regNo : '--' }}"
                />
              </mat-form-field>
            </div>
            <!-- Invoice Date -->
            <div class="form-group">
              <label for="invoicedate" class="form-label">Invoice Date</label>
              <mat-form-field appearance="outline">
                <mat-label>Invoice Date</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.invoicedate ? ticketDetails.invoicedate : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Invoice Number -->
            <div class="form-group">
              <label for="invoiceNo" class="form-label">Invoice Number</label>
              <mat-form-field appearance="outline">
                <mat-label>Invoice Number</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.invoiceNo ? ticketDetails.invoiceNo : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- RTO State -->
            <div class="form-group">
              <label for="rtoState" class="form-label">RTO State</label>
              <mat-form-field appearance="outline">
                <mat-label>RTO State</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.rtoState ? ticketDetails.rtoState : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- RTO Code -->
            <div class="form-group">
              <label for="rtoOfficeCode" class="form-label">RTO Code</label>
              <mat-form-field appearance="outline">
                <mat-label>RTO Code</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.rtoOfficeCode
                      ? ticketDetails.rtoOfficeCode
                      : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Ignition Status -->
            <div class="form-group">
              <label for="ignitionStatus" class="form-label"
                >Ignition Status</label
              >
              <mat-form-field
                class="file-upload-container"
                appearance="outline"
              >
                <mat-label>Ignition Status</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{ ignitionStatus ? 'ON' : 'OFF' }}"
                />
                <button
                  type="button"
                  mat-button
                  class="upload-btn"
                  (click)="getIgnitionStatus()"
                >
                  <mat-icon>refresh</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Dealer Information -->
    <div class="component-container">
      <!-- Component Header Section -->
      <div
        class="component-header"
        (click)="dealerInfoToggle()"
        tabindex="0"
        (keydown.enter)="dealerInfoToggle()"
      >
        <h6 class="component-title">Dealer Information</h6>
        <div class="component-actions">
          @if (!dealerInfoDrop) {
            <button type="button" class="primary-button" (click)="(0)">
              <mat-icon class="btn-icon">expand_more </mat-icon>
            </button>
          }
          @if (dealerInfoDrop) {
            <button type="button" class="primary-button" (click)="(0)">
              <mat-icon class="btn-icon">expand_less </mat-icon>
            </button>
          }
        </div>
      </div>
      @if (dealerInfoDrop) {
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <!-- Component Body Section -->
        <div class="component-body">
          <div class="form-section">
            <!-- Dealer Code -->
            <div class="form-group">
              <label for="dealerCode" class="form-label">Dealer Code</label>
              <mat-form-field appearance="outline">
                <mat-label>Dealer Code</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    ticketDetails.dealerCode ? ticketDetails.dealerCode : '--'
                  }}"
                />
              </mat-form-field>
            </div>
            <!-- Dealer Email -->
            <div class="form-group">
              <label for="email" class="form-label">Dealer Email</label>
              <mat-form-field appearance="outline">
                <mat-label>Dealer Email</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{ dealerData?.email ? dealerData?.email : '--' }}"
                />
              </mat-form-field>
            </div>
            <!-- Dealer City -->
            <div class="form-group">
              <label for="city" class="form-label">Dealer City</label>
              <mat-form-field appearance="outline">
                <mat-label>Dealer City</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{ dealerData?.city ? dealerData?.city : '--' }}"
                />
              </mat-form-field>
            </div>
            <!-- Dealer Phone Number -->
            <div class="form-group">
              <label for="mobile" class="form-label">Dealer Phone Number</label>
              <mat-form-field appearance="outline">
                <mat-label>Dealer Phone Number</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{ dealerData?.mobile ? dealerData?.mobile : '--' }}"
                />
              </mat-form-field>
            </div>
            <!-- POS Name -->
            <div class="form-group">
              <label for="posName" class="form-label">POS Name</label>
              <mat-form-field appearance="outline">
                <mat-label>POS Name</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{ dealerData?.posName ? dealerData?.posName : '--' }}"
                />
              </mat-form-field>
            </div>
            <!-- POS Code -->
            <div class="form-group">
              <label for="posCode" class="form-label">POS Code</label>
              <mat-form-field appearance="outline">
                <mat-label>POS Code</mat-label>
                <input
                  matInput
                  readonly
                  type="text"
                  value="{{
                    dealerData?.posCode
                      ? dealerData?.posCode
                      : ticketDetails.posCode
                        ? ticketDetails.posCode
                        : '--'
                  }}"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Device Fota Status Information -->
    @if (isFotaRequired) {
      <div class="component-container">
        <!-- Component Header Section -->
        <div
          class="component-header"
          (click)="fotaStatusInfoToggle()"
          tabindex="0"
          (keydown.enter)="fotaStatusInfoToggle()"
        >
          <h6 class="component-title">Device Fota Status Information</h6>
          <div class="component-actions">
            @if (!fotaStatusInfoDrop) {
              <button type="button" class="primary-button" (click)="(0)">
                <mat-icon class="btn-icon">expand_more </mat-icon>
              </button>
            }
            @if (fotaStatusInfoDrop) {
              <button type="button" class="primary-button" (click)="(0)">
                <mat-icon class="btn-icon">expand_less </mat-icon>
              </button>
            }
          </div>
        </div>
        @if (fotaStatusInfoDrop) {
          <!-- Separator between Header and Body -->
          <div class="component-separator"></div>
          <!-- Component Body Section -->

          @if (ticketDetails.fotaBatchRef) {
            <div class="component-body">
              <div class="form-section">
                <!-- FOTA Batch ID -->
                <div class="form-group">
                  <label for="batchId" class="form-label">FOTA Batch ID</label>
                  <mat-form-field appearance="outline">
                    <mat-label>FOTA Batch ID</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{
                        fotaBatchDeviceDataObj.batchId.batchId
                          ? fotaBatchDeviceDataObj.batchId.batchId
                          : '--'
                      }}"
                    />
                  </mat-form-field>
                </div>
                <!-- Current Firmware -->
                <div class="form-group">
                  <label for="firmwareVersion" class="form-label"
                    >Current Firmware</label
                  >
                  <mat-form-field appearance="outline">
                    <mat-label>Current Firmware</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{
                        fotaBatchDeviceDataObj?.currentFirmwareVersion
                          ? fotaBatchDeviceDataObj?.currentFirmwareVersion
                          : '--'
                      }}"
                    />
                  </mat-form-field>
                </div>
                <!-- Assigned Firmware Version -->
                <div class="form-group">
                  <label for="ufw" class="form-label"
                    >Assigned Firmware Version</label
                  >
                  <mat-form-field appearance="outline">
                    <mat-label>Assigned Firmware Version</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{
                        fotaBatchDeviceDataObj?.targetFirmwareVersion
                          ? fotaBatchDeviceDataObj?.targetFirmwareVersion
                          : '--'
                      }}"
                    />
                  </mat-form-field>
                </div>
                <!-- FOTA Status -->
                <div class="form-group">
                  <label for="deviceFotaStatus" class="form-label"
                    >FOTA Status</label
                  >
                  <mat-form-field appearance="outline">
                    <mat-label>FOTA Status</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{
                        fotaBatchDeviceDataObj?.deviceFotaStatus
                          ? fotaBatchDeviceDataObj?.deviceFotaStatus
                          : '--'
                      }}"
                    />
                  </mat-form-field>
                </div>
                <!-- Fota Progress -->
                <div class="form-group">
                  <label for="fotaPercent" class="form-label"
                    >Fota Progress</label
                  >
                  <mat-form-field appearance="outline">
                    <mat-label>Fota Progress</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{
                        fotaBatchDeviceDataObj?.progress
                          ? fotaBatchDeviceDataObj?.progress + '%'
                          : '0%'
                      }}"
                    />
                  </mat-form-field>
                </div>
                <!-- 1st SEO -->
                <div class="form-group">
                  <label for="stateEnable" class="form-label">1st SEO</label>
                  <mat-form-field appearance="outline">
                    <mat-label>1st SEO</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{
                        fotaBatchDeviceDataObj?.stateEnable
                          ? fotaBatchDeviceDataObj?.stateEnable
                          : '--'
                      }}"
                    />
                  </mat-form-field>
                </div>
                <!-- 1st SEO Status -->
                <div class="form-group">
                  <label for="stateEnable" class="form-label"
                    >1st SEO Status</label
                  >
                  <mat-form-field appearance="outline">
                    <mat-label>1st SEO Status</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{ fotaBatchDeviceDataObj?.stateEnableSetStatus }}"
                    />
                  </mat-form-field>
                </div>
                <!-- Primary IP -->
                <div class="form-group">
                  <label for="primaryIp" class="form-label">Primary IP</label>
                  <mat-form-field appearance="outline">
                    <mat-label>Primary IP</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{
                        fotaBatchDeviceDataObj.govtIp1 &&
                        fotaBatchDeviceDataObj.govtPort1
                          ? fotaBatchDeviceDataObj.govtIp1 +
                            ':' +
                            fotaBatchDeviceDataObj.govtPort1
                          : '--'
                      }}"
                    />
                  </mat-form-field>
                </div>
                <!-- Primary IP OTA Status -->
                <div class="form-group">
                  <label for="primaryIpStatus" class="form-label"
                    >Primary IP OTA Status</label
                  >
                  <mat-form-field appearance="outline">
                    <mat-label>Primary IP OTA Status</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{ primaryIpStatus }}"
                    />
                  </mat-form-field>
                </div>
                <!-- Secondary IP -->
                <div class="form-group">
                  <label for="secondaryIp" class="form-label"
                    >Secondary IP</label
                  >
                  <mat-form-field appearance="outline">
                    <mat-label>Secondary IP</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{
                        fotaBatchDeviceDataObj.govtIp2 &&
                        fotaBatchDeviceDataObj.govtPort2
                          ? fotaBatchDeviceDataObj.govtIp2 +
                            ':' +
                            fotaBatchDeviceDataObj.govtPort2
                          : '--'
                      }}"
                    />
                  </mat-form-field>
                </div>
                <!-- Secondary IP OTA Status -->
                <div class="form-group">
                  <label for="secondaryIpStatus" class="form-label"
                    >Secondary IP OTA Status</label
                  >
                  <mat-form-field appearance="outline">
                    <mat-label>Secondary IP OTA Status</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{ secondaryIpStatus }}"
                    />
                  </mat-form-field>
                </div>
                <!-- 2nd SEO -->
                <div class="form-group">
                  <label for="secondaryStateEnable" class="form-label"
                    >2nd SEO</label
                  >
                  <mat-form-field appearance="outline">
                    <mat-label>2nd SEO</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{
                        fotaBatchDeviceDataObj?.secondaryStateEnable
                          ? fotaBatchDeviceDataObj?.secondaryStateEnable
                          : '--'
                      }}"
                    />
                  </mat-form-field>
                </div>
                <!-- 2nd SEO Status -->
                <div class="form-group">
                  <label for="secondaryStateEnable" class="form-label"
                    >2nd SEO Status</label
                  >
                  <mat-form-field appearance="outline">
                    <mat-label>2nd SEO Status</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{ secondaryStateEnableStatus }}"
                    />
                  </mat-form-field>
                </div>
                <!-- Third IP -->
                <div class="form-group">
                  <label for="thirdIp" class="form-label">Third IP</label>
                  <mat-form-field appearance="outline">
                    <mat-label>Third IP</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{
                        fotaBatchDeviceDataObj.govtIp3 &&
                        fotaBatchDeviceDataObj.govtPort3
                          ? fotaBatchDeviceDataObj.govtIp3 +
                            ':' +
                            fotaBatchDeviceDataObj.govtPort3
                          : '--'
                      }}"
                    />
                  </mat-form-field>
                </div>
                <!-- Third IP OTA Status -->
                <div class="form-group">
                  <label for="thirdIpStatus" class="form-label"
                    >Third IP OTA Status</label
                  >
                  <mat-form-field appearance="outline">
                    <mat-label>Third IP OTA Status</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{ thirdIpStatus }}"
                    />
                  </mat-form-field>
                </div>
                <!-- Fourth IP -->
                <div class="form-group">
                  <label for="fourthIp" class="form-label">Fourth IP</label>
                  <mat-form-field appearance="outline">
                    <mat-label>Fourth IP</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{
                        fotaBatchDeviceDataObj.govtIp4 &&
                        fotaBatchDeviceDataObj.govtPort4
                          ? fotaBatchDeviceDataObj.govtIp4 +
                            ':' +
                            fotaBatchDeviceDataObj.govtPort4
                          : '--'
                      }}"
                    />
                  </mat-form-field>
                </div>
                <!-- Fourth IP OTA Status -->
                <div class="form-group">
                  <label for="fourthIpStatus" class="form-label"
                    >Fourth IP OTA Status</label
                  >
                  <mat-form-field appearance="outline">
                    <mat-label>Fourth IP OTA Status</mat-label>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{ fourthIpStatus }}"
                    />
                  </mat-form-field>
                </div>
                <!-- Reason to Skip Stage 2 Restriction -->
                <div class="form-group">
                  <label for="forceStageEnableReason" class="form-label"
                    >Reason to Skip Stage 2 Restriction</label
                  >
                  <mat-form-field appearance="outline">
                    <mat-label>Reason to Skip Stage 2 Restriction</mat-label>
                    <mat-select
                      formControlName="forceStageEnableReason"
                      (selectionChange)="checkOtherSelected()"
                    >
                      <mat-option
                        value="The device already has the latest Bin, so no FOTA is required"
                        >The device already has the latest Bin, so no FOTA is
                        required</mat-option
                      >
                      <mat-option
                        value="OTA set using SMS OTA since not started using TCP OTA"
                        >OTA set using SMS OTA since not started using TCP
                        OTA</mat-option
                      >
                      <mat-option value="Other">Other</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                @if (enableRemark) {
                  <!-- Remark -->
                  <div class="form-group">
                    <label for="stageEnableRemark" class="form-label"
                      >Remark</label
                    >
                    <mat-form-field appearance="outline">
                      <mat-label>Remark</mat-label>
                      <input
                        matInput
                        type="text"
                        [readonly]="disableRemark"
                        formControlName="stageEnableRemark"
                      />
                      @if (
                        myActivationsDetailsForm.controls['stageEnableRemark']
                          .touched &&
                        myActivationsDetailsForm.controls['stageEnableRemark']
                          .errors?.required
                      ) {
                        <mat-error class="mt-1">
                          This field is mandatory.
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                <!-- Skipped By -->
                <div class="form-group">
                  <label for="skippedName" class="form-label">Skipped By</label>
                  <mat-form-field appearance="outline">
                    <mat-label>Skipped By</mat-label>
                    <input
                      type="text"
                      matInput
                      readonly
                      formControlName="skippedName"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="component-separator"></div>
            <div class="component-footer">
              <div class="button-group">
                <!-- Remove Stage 2 Restriction -->
                <button
                  type="button"
                  class="edit-button"
                  [disabled]="checkStageEnableState()"
                  (click)="forceStageEnableClick()"
                >
                  Remove Stage 2 Restriction
                  <mat-icon class="btn-icon">lock_open</mat-icon>
                </button>
              </div>
            </div>
          } @else if (ticketDetails.deviceType === 'ATCU2G') {
            <form [formGroup]="fotaForm">
              <div class="component-body">
                <div class="form-section">
                  <!-- FOTA Batch ID -->
                  <div class="form-group">
                    <label for="BatchId" class="form-label"
                      >FOTA Batch ID</label
                    >
                    <mat-form-field appearance="outline">
                      <mat-label>FOTA Batch ID</mat-label>
                      <input formControlName="BatchId" matInput type="text" />
                    </mat-form-field>
                  </div>
                  <!-- Current Firmware -->
                  <div class="form-group">
                    <label for="currentFirmware" class="form-label"
                      >Current Firmware</label
                    >
                    <mat-form-field appearance="outline">
                      <mat-label>Current Firmware</mat-label>
                      <input
                        formControlName="currentFirmware"
                        matInput
                        type="text"
                      />
                    </mat-form-field>
                  </div>
                  <!-- Assigned Firmware Version -->
                  <div class="form-group">
                    <label for="assignedFirmware" class="form-label"
                      >Assigned Firmware Version</label
                    >
                    <mat-form-field appearance="outline">
                      <mat-label>Assigned Firmware Version</mat-label>
                      <input
                        formControlName="assignedFirmware"
                        matInput
                        type="text"
                      />
                    </mat-form-field>
                  </div>
                  <!-- FOTA Status -->
                  <div class="form-group">
                    <label for="fotaStatus" class="form-label"
                      >FOTA Status</label
                    >
                    <mat-form-field appearance="outline">
                      <mat-label>FOTA Status</mat-label>
                      <mat-select formControlName="fotaStatus">
                        <mat-option value="Completed">Completed</mat-option>
                        <mat-option value="Pending">Pending</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- FOTA Progress -->
                  <div class="form-group">
                    <label for="fotaProgress" class="form-label"
                      >FOTA Progress</label
                    >
                    <mat-form-field appearance="outline">
                      <mat-label>FOTA Progress</mat-label>
                      <input
                        formControlName="fotaProgress"
                        matInput
                        type="text"
                      />
                    </mat-form-field>
                  </div>
                  <!-- Primary IP OTA  -->
                  <div class="form-group">
                    <label for="otaPrimaryIp" class="form-label"
                      >Primary IP OTA
                    </label>
                    <mat-form-field appearance="outline">
                      <mat-label>Primary IP OTA </mat-label>
                      <input
                        formControlName="otaPrimaryIp"
                        matInput
                        type="text"
                      />
                    </mat-form-field>
                  </div>
                  <!-- Primary IP OTA Status  -->
                  <div class="form-group">
                    <label for="otaPrimaryIpStatus" class="form-label"
                      >Primary IP OTA Status
                    </label>
                    <mat-form-field appearance="outline">
                      <mat-label>Primary IP OTA Status </mat-label>
                      <mat-select formControlName="otaPrimaryIpStatus">
                        <mat-option value="Completed">Completed</mat-option>
                        <mat-option value="In Progress">In Progress</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- Secondary IP OTA  -->
                  <div class="form-group">
                    <label for="otaSecondaryIp" class="form-label"
                      >Secondary IP OTA
                    </label>
                    <mat-form-field appearance="outline">
                      <mat-label>Secondary IP OTA </mat-label>
                      <input
                        formControlName="otaSecondaryIp"
                        matInput
                        type="text"
                      />
                    </mat-form-field>
                  </div>
                  <!-- Secondary IP OTA Status  -->
                  <div class="form-group">
                    <label for="otaSecondaryIpStatus" class="form-label"
                      >Secondary IP OTA Status
                    </label>
                    <mat-form-field appearance="outline">
                      <mat-label>Secondary IP OTA Status </mat-label>
                      <mat-select formControlName="otaSecondaryIpStatus">
                        <mat-option value="Completed">Completed</mat-option>
                        <mat-option value="In Progress">In Progress</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- SEO Status -->
                  <div class="form-group">
                    <label for="stateEnableOtaStatus" class="form-label"
                      >SEO Status</label
                    >
                    <mat-form-field appearance="outline">
                      <mat-label>SEO Status</mat-label>
                      <mat-select formControlName="stateEnableOtaStatus">
                        <mat-option value="SET">SET</mat-option>
                        <mat-option value="NOT SET">NOT SET</mat-option>
                        <mat-option value="Skipped">Skipped</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="component-separator"></div>
              <div class="component-footer">
                <div class="button-group">
                  <!-- Update FOTA Status -->
                  <button
                    type="button"
                    class="edit-button"
                    (click)="getFotaDeviceDetails()"
                  >
                    Update FOTA Status
                    <mat-icon class="btn-icon">edit</mat-icon>
                  </button>
                </div>
              </div>
            </form>
          }
        }
      </div>
    }

    <!-- Device Ticket Status -->
    <div class="component-container">
      <!-- Component Header Section -->
      <div class="component-header">
        <h6 class="component-title">Device Ticket Status</h6>
      </div>
      <div class="component-separator"></div>
      <div class="component-body">
        <!-- Stage 1: FOTA / OTA Activities -->
        <div class="component-container">
          <div
            class="component-subheader"
            (click)="Stage1Toggle()"
            tabindex="0"
            (keydown.enter)="Stage1Toggle()"
          >
            <h6 class="component-subtitle">Stage 1: FOTA / OTA Activities</h6>
            <div class="component-actions">
              @if (!stage1Drop) {
                <button type="button" class="primary-button" (click)="(0)">
                  <mat-icon class="btn-icon">expand_more </mat-icon>
                </button>
              }
              @if (stage1Drop) {
                <button type="button" class="primary-button" (click)="(0)">
                  <mat-icon class="btn-icon">expand_less </mat-icon>
                </button>
              }
            </div>
          </div>
          @if (
            stage1Drop ||
            !myActivationsDetailsForm.get('stage1status1')?.disabled ||
            !myActivationsDetailsForm.get('stage1status2')?.disabled ||
            !myActivationsDetailsForm.get('stage1status3')?.disabled
          ) {
            <!-- Separator between Header and Body -->
            <div class="component-separator"></div>
            <!-- Component Body Section -->
            <div class="component-body">
              <div class="form-section three-columns">
                <!-- Dealer Request / Vehicle Ignition On -->
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activity</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="stage1Associated1"
                      readonly
                    />
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Status</mat-label>
                    <mat-select formControlName="stage1status1">
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="ticketStage1Status1FilterCtrl"
                          [noEntriesFoundLabel]="'No options found'"
                          placeholderLabel="Filter"
                          (filteredReturn)="
                            filteredStage1Status1TicketStatus = $any($event)
                          "
                        >
                        </ngx-mat-select-search>
                      </mat-option>
                      @for (
                        value of filteredStage1Status1TicketStatus;
                        track value
                      ) {
                        <mat-option [value]="value.statusCode">{{
                          value.status
                        }}</mat-option>
                      }
                    </mat-select>
                    @if (
                      myActivationsDetailsForm.controls['stage1status1']
                        .touched &&
                      myActivationsDetailsForm.controls['stage1status1'].errors
                        ?.required
                    ) {
                      <mat-error> This field is mandatory. </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Remark</mat-label>
                    <input
                      matInput
                      [readonly]="
                        myActivationsDetailsForm.get('stage1status1')?.disabled
                      "
                      formControlName="stage1remark1"
                      [matAutocomplete]="remarkAuto1"
                      type="text"
                    />
                    <mat-autocomplete #remarkAuto1="matAutocomplete">
                      @for (
                        option of filteredRemarks(
                          myActivationsDetailsForm.get('stage1remark1')?.value
                        );
                        track option
                      ) {
                        <mat-option [value]="option">
                          {{ option }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <!-- GSM Network Availability -->
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="stage1Associated2"
                      readonly
                    />
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Status</mat-label>
                    <mat-select formControlName="stage1status2">
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="ticketStage1Status2FilterCtrl"
                          [noEntriesFoundLabel]="'No options found'"
                          placeholderLabel="Filter"
                          (filteredReturn)="
                            filteredStage1Status2TicketStatus = $any($event)
                          "
                        >
                        </ngx-mat-select-search>
                      </mat-option>
                      @for (
                        value of filteredStage1Status2TicketStatus;
                        track value
                      ) {
                        <mat-option [value]="value.statusCode">{{
                          value.status
                        }}</mat-option>
                      }
                    </mat-select>
                    @if (
                      myActivationsDetailsForm.controls['stage1status2']
                        .touched &&
                      myActivationsDetailsForm.controls['stage1status2'].errors
                        ?.required
                    ) {
                      <mat-error> This field is mandatory. </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Remark</mat-label>
                    <input
                      matInput
                      [readonly]="
                        myActivationsDetailsForm.get('stage1status2')?.disabled
                      "
                      formControlName="stage1remark2"
                      [matAutocomplete]="remarkAuto2"
                      type="text"
                    />
                    <mat-autocomplete #remarkAuto2="matAutocomplete">
                      @for (
                        option of filteredRemarks(
                          myActivationsDetailsForm.get('stage1remark2')?.value
                        );
                        track option
                      ) {
                        <mat-option [value]="option">
                          {{ option }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <!-- GPS Fix availability -->
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="stage1Associated3"
                      readonly
                    />
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Status</mat-label>
                    <mat-select formControlName="stage1status3">
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="ticketStage1Status3FilterCtrl"
                          [noEntriesFoundLabel]="'No options found'"
                          placeholderLabel="Filter"
                          (filteredReturn)="
                            filteredStage1Status3TicketStatus = $any($event)
                          "
                        >
                        </ngx-mat-select-search>
                      </mat-option>
                      @for (
                        value of filteredStage1Status3TicketStatus;
                        track value
                      ) {
                        <mat-option [value]="value.statusCode">{{
                          value.status
                        }}</mat-option>
                      }
                    </mat-select>
                    @if (
                      myActivationsDetailsForm.controls['stage1status3']
                        .touched &&
                      myActivationsDetailsForm.controls['stage1status3'].errors
                        ?.required
                    ) {
                      <mat-error> This field is mandatory. </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Remark</mat-label>
                    <input
                      matInput
                      [readonly]="
                        myActivationsDetailsForm.get('stage1status3')?.disabled
                      "
                      formControlName="stage1remark3"
                      [matAutocomplete]="remarkAuto3"
                      type="text"
                    />
                    <mat-autocomplete #remarkAuto3="matAutocomplete">
                      @for (
                        option of filteredRemarks(
                          myActivationsDetailsForm.get('stage1remark3')?.value
                        );
                        track option
                      ) {
                        <mat-option [value]="option">
                          {{ option }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="component-separator"></div>
            <div class="component-footer">
              <div class="button-group">
                <button
                  type="button"
                  class="clear-button"
                  [disabled]="
                    !(
                      !myActivationsDetailsForm.get('stage1status1')
                        ?.disabled ||
                      !myActivationsDetailsForm.get('stage1status2')
                        ?.disabled ||
                      !myActivationsDetailsForm.get('stage1status3')?.disabled
                    ) ||
                    !updateButtonVisible ||
                    !myActivationsDetailsForm.get('remarkbyaccolade')?.value
                  "
                  (click)="openVahanCertificateLink()"
                >
                  Generate Vahan Certificate Links
                  <mat-icon class="btn-icon">open_in_new</mat-icon>
                </button>
                @if (MyActivationsUpdate) {
                  <button
                    type="button"
                    class="edit-button"
                    [disabled]="
                      !(
                        !myActivationsDetailsForm.get('stage1status1')
                          ?.disabled ||
                        !myActivationsDetailsForm.get('stage1status2')
                          ?.disabled ||
                        !myActivationsDetailsForm.get('stage1status3')?.disabled
                      ) ||
                      !updateButtonVisible ||
                      !myActivationsDetailsForm.get('remarkbyaccolade')?.value
                    "
                    (click)="markStageAsComplete(1)"
                  >
                    Mark Stage 1 as Complete
                    <mat-icon class="btn-icon">flag</mat-icon>
                  </button>
                }
              </div>
            </div>
          }
        </div>

        <!-- Stage 2: FOTA / OTA Activities -->
        <div class="component-container">
          <div
            class="component-subheader"
            (click)="Stage2Toggle()"
            tabindex="0"
            (keydown.enter)="Stage2Toggle()"
          >
            <h6 class="component-subtitle">Stage 2: Vahan Certification</h6>
            <div class="component-actions">
              @if (!stage2Drop) {
                <button type="button" class="primary-button" (click)="(0)">
                  <mat-icon class="btn-icon">expand_more </mat-icon>
                </button>
              }
              @if (stage2Drop) {
                <button type="button" class="primary-button" (click)="(0)">
                  <mat-icon class="btn-icon">expand_less </mat-icon>
                </button>
              }
            </div>
          </div>
          @if (
            stage2Drop ||
            !myActivationsDetailsForm.get('stage2status1')?.disabled ||
            !myActivationsDetailsForm.get('stage2status2')?.disabled
          ) {
            <!-- Separator between Header and Body -->
            <div class="component-separator"></div>
            <!-- Component Body Section -->
            <div class="component-body">
              <div class="form-section three-columns">
                <!-- Vahan Portal Availability -->
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activity</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="stage2Associated1"
                      readonly
                    />
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Status</mat-label>
                    <mat-select formControlName="stage2status1">
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="ticketStage2StatusFilterCtrl"
                          [noEntriesFoundLabel]="'No options found'"
                          placeholderLabel="Filter"
                          (filteredReturn)="
                            filteredStage2TicketStatus = $any($event)
                          "
                        >
                        </ngx-mat-select-search>
                      </mat-option>
                      @for (value of filteredStage2TicketStatus; track value) {
                        <mat-option [value]="value.statusCode">{{
                          value.status
                        }}</mat-option>
                      }
                    </mat-select>
                    @if (
                      myActivationsDetailsForm.controls['stage2status1']
                        .touched &&
                      myActivationsDetailsForm.controls['stage2status1'].errors
                        ?.required
                    ) {
                      <mat-error> This field is mandatory. </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Remark</mat-label>
                    <input
                      matInput
                      [readonly]="
                        myActivationsDetailsForm.get('stage2status1')?.disabled
                      "
                      formControlName="stage2remark1"
                      [matAutocomplete]="remarkAuto4"
                      type="text"
                    />
                    <mat-autocomplete #remarkAuto4="matAutocomplete">
                      @for (
                        option of filteredRemarks(
                          myActivationsDetailsForm.get('stage2remark1')?.value
                        );
                        track option
                      ) {
                        <mat-option [value]="option">
                          {{ option }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <!-- Vehicle Data availability on Vahan -->
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="stage2Associated2"
                      readonly
                    />
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Status</mat-label>
                    <mat-select formControlName="stage2status2">
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="ticketStage2StatusFilterCtrl"
                          [noEntriesFoundLabel]="'No options found'"
                          placeholderLabel="Filter"
                          (filteredReturn)="
                            filteredStage2TicketStatus = $any($event)
                          "
                        >
                        </ngx-mat-select-search>
                      </mat-option>
                      @for (value of filteredStage2TicketStatus; track value) {
                        <mat-option
                          [value]="value.statusCode"
                          (click)="stage2Complete()"
                          >{{ value.status }}</mat-option
                        >
                      }
                    </mat-select>
                    @if (
                      myActivationsDetailsForm.controls['stage2status2']
                        .touched &&
                      myActivationsDetailsForm.controls['stage2status2'].errors
                        ?.required
                    ) {
                      <mat-error> This field is mandatory. </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Remark</mat-label>
                    <input
                      matInput
                      [readonly]="
                        myActivationsDetailsForm.get('stage2status2')?.disabled
                      "
                      formControlName="stage2remark2"
                      [matAutocomplete]="remarkAuto5"
                      type="text"
                    />
                    <mat-autocomplete #remarkAuto5="matAutocomplete">
                      @for (
                        option of filteredRemarks(
                          myActivationsDetailsForm.get('stage2remark2')?.value
                        );
                        track option
                      ) {
                        <mat-option [value]="option">
                          {{ option }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="component-separator"></div>
            <div class="component-footer">
              <div class="button-group">
                <button
                  type="button"
                  class="clear-button"
                  [disabled]="
                    !(
                      !myActivationsDetailsForm.get('stage2status1')
                        ?.disabled ||
                      !myActivationsDetailsForm.get('stage2status2')?.disabled
                    ) ||
                    !updateButtonVisible ||
                    !myActivationsDetailsForm.get('remarkbyaccolade')?.value
                  "
                  (click)="openBackendCertificatePopUp()"
                >
                  Generate Backend Certificate
                  <mat-icon class="btn-icon">open_in_new</mat-icon>
                </button>
                @if (MyActivationsUpdate) {
                  <button
                    type="button"
                    class="edit-button"
                    [disabled]="
                      !(
                        !myActivationsDetailsForm.get('stage2status1')
                          ?.disabled ||
                        !myActivationsDetailsForm.get('stage2status2')?.disabled
                      ) ||
                      !updateButtonVisible ||
                      !myActivationsDetailsForm.get('remarkbyaccolade')?.value
                    "
                    (click)="markStageAsComplete(2)"
                  >
                    Mark Stage 2 as Complete
                    <mat-icon class="btn-icon">flag</mat-icon>
                  </button>
                }
              </div>
            </div>
          }
        </div>

        <!-- Stage 3: AIS-140 Certification -->
        <div class="component-container">
          <div
            class="component-subheader"
            (click)="stage3Toggle()"
            tabindex="0"
            (keydown.enter)="stage3Toggle()"
          >
            <h6 class="component-subtitle">Stage 3: AIS-140 Certification</h6>
            <div class="component-actions">
              @if (!stage3Drop) {
                <button type="button" class="primary-button" (click)="(0)">
                  <mat-icon class="btn-icon">expand_more </mat-icon>
                </button>
              }
              @if (stage3Drop) {
                <button type="button" class="primary-button" (click)="(0)">
                  <mat-icon class="btn-icon">expand_less </mat-icon>
                </button>
              }
            </div>
          </div>
          @if (stage3Drop) {
            <!-- Separator between Header and Body -->
            <div class="component-separator"></div>
            <!-- Component Body Section -->
            <div class="component-body">
              <div class="form-section three-columns">
                <!-- Backend Portal Availability -->
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activity</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="stage3Associated1"
                      readonly
                    />
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Status</mat-label>
                    <mat-select formControlName="stage3status1">
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="ticketStage3StatusFilterCtrl"
                          [noEntriesFoundLabel]="'No options found'"
                          placeholderLabel="Filter"
                          (filteredReturn)="
                            filteredStage3TicketStatus = $any($event)
                          "
                        >
                        </ngx-mat-select-search>
                      </mat-option>
                      @for (value of filteredStage3TicketStatus; track value) {
                        <mat-option [value]="value.statusCode">{{
                          value.status
                        }}</mat-option>
                      }
                    </mat-select>
                    @if (
                      myActivationsDetailsForm.controls['stage3status1']
                        .touched &&
                      myActivationsDetailsForm.controls['stage3status1'].errors
                        ?.required
                    ) {
                      <mat-error> This field is mandatory. </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Remark</mat-label>
                    <input
                      matInput
                      [readonly]="
                        myActivationsDetailsForm.get('stage3status1')?.disabled
                      "
                      formControlName="stage3remark1"
                      [matAutocomplete]="remarkAuto6"
                      type="text"
                    />
                    <mat-autocomplete #remarkAuto6="matAutocomplete">
                      @for (
                        option of filteredRemarks(
                          myActivationsDetailsForm.get('stage3remark1')?.value
                        );
                        track option
                      ) {
                        <mat-option [value]="option">
                          {{ option }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <!-- Panic Event Confirmation -->
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="stage3Associated2"
                      readonly
                    />
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Status</mat-label>
                    <mat-select formControlName="stage3status2">
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="ticketStage3StatusFilterCtrl"
                          [noEntriesFoundLabel]="'No options found'"
                          placeholderLabel="Filter"
                          (filteredReturn)="
                            filteredStage3TicketStatus = $any($event)
                          "
                        >
                        </ngx-mat-select-search>
                      </mat-option>
                      @for (value of filteredStage3TicketStatus; track value) {
                        <mat-option [value]="value.statusCode">{{
                          value.status
                        }}</mat-option>
                      }
                    </mat-select>
                    @if (
                      myActivationsDetailsForm.controls['stage3status2']
                        .touched &&
                      myActivationsDetailsForm.controls['stage3status2'].errors
                        ?.required
                    ) {
                      <mat-error> This field is mandatory. </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Remark</mat-label>
                    <input
                      matInput
                      [readonly]="
                        myActivationsDetailsForm.get('stage3status2')?.disabled
                      "
                      formControlName="stage3remark2"
                      [matAutocomplete]="remarkAuto7"
                      type="text"
                    />
                    <mat-autocomplete #remarkAuto7="matAutocomplete">
                      @for (
                        option of filteredRemarks(
                          myActivationsDetailsForm.get('stage3remark2')?.value
                        );
                        track option
                      ) {
                        <mat-option [value]="option">
                          {{ option }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <!-- OTP / Live Location Fetching -->
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="stage3Associated3"
                      readonly
                    />
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Status</mat-label>
                    <mat-select formControlName="stage3status3">
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="ticketStage3StatusFilterCtrl"
                          [noEntriesFoundLabel]="'No options found'"
                          placeholderLabel="Filter"
                          (filteredReturn)="
                            filteredStage3TicketStatus = $any($event)
                          "
                        >
                        </ngx-mat-select-search>
                      </mat-option>
                      @for (value of filteredStage3TicketStatus; track value) {
                        <mat-option [value]="value.statusCode">{{
                          value.status
                        }}</mat-option>
                      }
                    </mat-select>
                    @if (
                      myActivationsDetailsForm.controls['stage3status3']
                        .touched &&
                      myActivationsDetailsForm.controls['stage3status3'].errors
                        ?.required
                    ) {
                      <mat-error> This field is mandatory. </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Remark</mat-label>
                    <input
                      matInput
                      [readonly]="
                        myActivationsDetailsForm.get('stage3status3')?.disabled
                      "
                      formControlName="stage3remark3"
                      [matAutocomplete]="remarkAuto8"
                      type="text"
                    />
                    <mat-autocomplete #remarkAuto8="matAutocomplete">
                      @for (
                        option of filteredRemarks(
                          myActivationsDetailsForm.get('stage3remark3')?.value
                        );
                        track option
                      ) {
                        <mat-option [value]="option">
                          {{ option }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="component-separator"></div>
            <div class="component-footer">
              <div class="button-group">
                @if (MyActivationsUpdate) {
                  <button
                    type="button"
                    class="edit-button"
                    [disabled]="
                      !(
                        !myActivationsDetailsForm.get('stage3status1')
                          ?.disabled ||
                        !myActivationsDetailsForm.get('stage3status2')
                          ?.disabled ||
                        !myActivationsDetailsForm.get('stage3status3')?.disabled
                      ) ||
                      !updateButtonVisible ||
                      !myActivationsDetailsForm.get('remarkbyaccolade')?.value
                    "
                    (click)="markStageAsComplete(3)"
                  >
                    Mark Stage 3 as Complete
                    <mat-icon class="btn-icon">flag</mat-icon>
                  </button>
                }
              </div>
            </div>
          }
        </div>

        <!-- Stage 4: Certificate Generation / Submission -->
        <div class="component-container">
          <div
            class="component-subheader"
            (click)="stage4Toggle()"
            tabindex="0"
            (keydown.enter)="stage4Toggle()"
          >
            <h6 class="component-subtitle">
              Stage 4: Certificate Generation / Submission
            </h6>
            <div class="component-actions">
              @if (!stage4Drop) {
                <button type="button" class="primary-button" (click)="(0)">
                  <mat-icon class="btn-icon">expand_more </mat-icon>
                </button>
              }
              @if (stage4Drop) {
                <button type="button" class="primary-button" (click)="(0)">
                  <mat-icon class="btn-icon">expand_less </mat-icon>
                </button>
              }
            </div>
          </div>
          @if (stage4Drop) {
            <!-- Separator between Header and Body -->
            <div class="component-separator"></div>
            <!-- Component Body Section -->
            <div class="component-body">
              <div class="form-section three-columns">
                <!-- Backend Portal Availability -->
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activity</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="stage4Associated1"
                      readonly
                    />
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Status</mat-label>
                    <mat-select formControlName="stage4status1">
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="ticketStage4StatusFilterCtrl"
                          [noEntriesFoundLabel]="'No options found'"
                          placeholderLabel="Filter"
                          (filteredReturn)="
                            filteredStage4TicketStatus = $any($event)
                          "
                        >
                        </ngx-mat-select-search>
                      </mat-option>
                      @for (value of filteredStage4TicketStatus; track value) {
                        <mat-option [value]="value.statusCode">{{
                          value.status
                        }}</mat-option>
                      }
                    </mat-select>
                    @if (
                      myActivationsDetailsForm.controls['stage4status1']
                        .touched &&
                      myActivationsDetailsForm.controls['stage4status1'].errors
                        ?.required
                    ) {
                      <mat-error> This field is mandatory. </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Associated Activities Remark</mat-label>
                    <input
                      matInput
                      [readonly]="
                        myActivationsDetailsForm.get('stage4status1')?.disabled
                      "
                      formControlName="stage4remark1"
                      [matAutocomplete]="remarkAuto9"
                      type="text"
                    />
                    <mat-autocomplete #remarkAuto9="matAutocomplete">
                      @for (
                        option of filteredRemarks(
                          myActivationsDetailsForm.get('stage4remark1')?.value
                        );
                        track option
                      ) {
                        <mat-option [value]="option">
                          {{ option }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="component-separator"></div>
            <div class="component-footer">
              <div class="button-group">
                @if (MyActivationsUpdate) {
                  <button
                    type="button"
                    class="edit-button"
                    [disabled]="
                      myActivationsDetailsForm.get('stage4status1')?.disabled ||
                      !updateButtonVisible ||
                      !myActivationsDetailsForm.get('remarkbyaccolade')?.value
                    "
                    (click)="markStageAsComplete(4)"
                  >
                    Mark Stage 4 as Complete
                    <mat-icon class="btn-icon">flag</mat-icon>
                  </button>
                }
              </div>
            </div>
          }
        </div>
        @if (certificates) {
          <!-- Certificate Validity Duration Date Submission -->
          <div class="component-container">
            <div class="component-subheader">
              <h6 class="component-subtitle">Certificate Validity Duration</h6>
            </div>
            <!-- Separator between Header and Body -->
            <div class="component-separator"></div>
            <!-- Component Body Section -->
            <div class="component-body">
              <div class="form-section three-columns">
                <!-- Certificate Validity Start Date -->
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Certificate Validity Start Date</mat-label>
                    <input
                      formControlName="certificateStartDate"
                      matInput
                      [matDatepicker]="certificateStartDate"
                      [max]="today"
                      [max]="
                        myActivationsDetailsForm.value.certificateExpiryDate ||
                        today
                      "
                      id="certificateStartDate"
                      placeholder="Certificate Validity Start Date"
                      readonly
                      (dateChange)="toExpiryDateChange()"
                      (click)="toExpiryDateChange()"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="certificateStartDate"
                    >
                    </mat-datepicker-toggle>
                    <mat-datepicker #certificateStartDate></mat-datepicker>
                    @if (
                      myActivationsDetailsForm.controls['certificateStartDate']
                        .touched &&
                      myActivationsDetailsForm.controls['certificateStartDate']
                        .errors?.required
                    ) {
                      <mat-error> This Field Is Mandatory. </mat-error>
                    }
                  </mat-form-field>
                </div>
                <!-- Select Certificate Validity Duration -->
                <div class="form-group">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label class="lable_style2"
                      >Select Certificate Validity Duration</mat-label
                    >
                    <mat-select
                      [disabled]="!updateButtonVisible"
                      [(ngModel)]="certificateExpiryTime"
                      name="certificateExpiryTime"
                      (selectionChange)="setCertificateDate()"
                      [ngModelOptions]="{ standalone: true }"
                    >
                      <mat-option value="1">1 Year</mat-option>
                      <mat-option value="2">2 Year</mat-option>
                      <mat-option value="3">3 Year</mat-option>
                      <mat-option value="4">4 Year</mat-option>
                      <mat-option value="5">5 Year</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Certificate Validity Expiry Date -->
                <div class="form-group">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Certificate Validity Expiry Date</mat-label>
                    <input
                      formControlName="certificateExpiryDate"
                      matInput
                      (dateChange)="toExpiryDateChange()"
                      [matDatepicker]="certificateExpiryDate"
                      id="certificateExpiryDate"
                      readonly
                      (click)="toExpiryDateChange()"
                      [min]="
                        myActivationsDetailsForm.value.certificateStartDate ||
                        ''
                      "
                      placeholder="Certificate Validity Expiry Date"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="certificateExpiryDate"
                    >
                    </mat-datepicker-toggle>
                    <mat-datepicker #certificateExpiryDate></mat-datepicker>
                    @if (
                      myActivationsDetailsForm.controls['certificateExpiryDate']
                        .touched &&
                      myActivationsDetailsForm.controls['certificateExpiryDate']
                        .errors?.required
                    ) {
                      <mat-error class="mt-1">
                        This Field Is Mandatory.
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          @if (MyActivationsUpdate) {
            <!-- Certificate Upload -->
            <div class="component-container">
              <div class="component-subheader">
                <h6 class="component-subtitle">Certificate Upload</h6>
              </div>
              <!-- Separator between Header and Body -->
              <div class="component-separator"></div>
              <!-- Component Body Section -->
              <div class="component-body">
                <form [formGroup]="fileNameForm">
                  <div class="form-section three-columns">
                    <!-- Upload Vehicle Certificate -->
                    <div class="form-group">
                      @if (MyActivationsUpdate) {
                        <mat-form-field
                          class="file-upload-container"
                          appearance="outline"
                        >
                          <mat-label>Upload Vehicle Certificate</mat-label>
                          <!-- Display File Name or Placeholder -->
                          <input
                            matInput
                            type="text"
                            formControlName="vahanCertificateName"
                            [value]="
                              fileNameForm.controls['vahanCertificateName']
                                .value
                            "
                            readonly
                          />
                          <!-- Hidden File Input -->
                          <input
                            type="file"
                            accept=".pdf"
                            aria-label="File"
                            class="d-none"
                            (change)="uploadVehicleCertificate($event)"
                            #fileUploadVehicle
                          />

                          <!-- Custom Upload Button -->
                          <button
                            type="button"
                            mat-button
                            class="upload-btn"
                            [disabled]="!updateButtonVisible"
                            (click)="fileUploadVehicle.click()"
                            type="button"
                          >
                            <mat-icon>attach_file</mat-icon>
                          </button>
                          @if (
                            fileNameForm.controls['vahanCertificateName']
                              .touched &&
                            fileNameForm.controls['vahanCertificateName'].errors
                              ?.required
                          ) {
                            <mat-error> This field is mandatory. </mat-error>
                          }
                        </mat-form-field>
                      }
                      @if (uploadedVahanCertificate) {
                        <button
                          type="button"
                          class="download-btn"
                          (click)="downloadCertificate('vahan')"
                        >
                          {{ uploadedVahanCertificate }}
                          <mat-icon class="btn-icon">download</mat-icon>
                        </button>
                      }
                    </div>
                    <!-- Upload Backend Certificate -->
                    <div class="form-group">
                      @if (MyActivationsUpdate) {
                        <mat-form-field
                          class="file-upload-container"
                          appearance="outline"
                        >
                          <mat-label>Upload Backend Certificate</mat-label>
                          <!-- Display File Name or Placeholder -->
                          <input
                            matInput
                            type="text"
                            formControlName="backendCertificateName"
                            [value]="
                              fileNameForm.controls['backendCertificateName']
                                .value
                            "
                            readonly
                          />
                          <!-- Hidden File Input -->
                          <input
                            type="file"
                            accept=".pdf"
                            aria-label="File"
                            class="d-none"
                            (change)="backendCertificate_upload($event)"
                            #fileUploadBackend
                          />

                          <!-- Custom Upload Button -->
                          <button
                            type="button"
                            mat-button
                            class="upload-btn"
                            [disabled]="!updateButtonVisible"
                            (click)="fileUploadBackend.click()"
                            type="button"
                          >
                            <mat-icon>attach_file</mat-icon>
                          </button>
                          @if (
                            fileNameForm.controls['backendCertificateName']
                              .touched &&
                            fileNameForm.controls['backendCertificateName']
                              .errors?.required
                          ) {
                            <mat-error> This field is mandatory. </mat-error>
                          }
                        </mat-form-field>
                      }
                      @if (uploadedBackendCertificate) {
                        <button
                          type="button"
                          class="download-btn"
                          (click)="downloadCertificate('backend')"
                        >
                          {{ uploadedBackendCertificate }}
                          <mat-icon class="btn-icon">download</mat-icon>
                        </button>
                      }
                    </div>
                    <!-- Upload Other Certificate -->
                    <div class="form-group">
                      @if (MyActivationsUpdate) {
                        <mat-form-field
                          class="file-upload-container"
                          appearance="outline"
                        >
                          <mat-label>Upload Other Certificate</mat-label>
                          <!-- Display File Name or Placeholder -->
                          <input
                            matInput
                            type="text"
                            formControlName="otherCertificate"
                            [value]="
                              fileNameForm.controls['otherCertificate'].value
                            "
                            readonly
                          />
                          <!-- Hidden File Input -->
                          <input
                            type="file"
                            accept=".pdf"
                            aria-label="File"
                            class="d-none"
                            (change)="otherCertificate_upload($event)"
                            multiple
                            #fileUploadOther
                          />

                          <!-- Custom Upload Button -->
                          <button
                            type="button"
                            mat-button
                            class="upload-btn"
                            [disabled]="!updateButtonVisible"
                            (click)="fileUploadOther.click()"
                            type="button"
                          >
                            <mat-icon>attach_file</mat-icon>
                          </button>
                        </mat-form-field>
                      }
                      @for (name of otherCertificate; track name) {
                        <button
                          type="button"
                          class="download-btn"
                          (click)="downloadCertificate(name)"
                        >
                          {{ name }}
                          <mat-icon class="btn-icon">download</mat-icon>
                        </button>
                      }
                    </div>
                  </div>
                </form>
              </div>
            </div>
          }
        }
        <div class="form-section three-columns">
          <!-- Overall Ticket Status -->
          <div class="form-group">
            <mat-form-field appearance="outline">
              <mat-label>Overall Ticket Status</mat-label>
              <mat-select
                #ticketStatusSelect
                formControlName="remarkbyaccolade"
                (selectionChange)="remarkChange()"
              >
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="ticketStatusFilterCtrl"
                    [noEntriesFoundLabel]="'No options found'"
                    placeholderLabel="Filter"
                    (filteredReturn)="filteredTicketStatus = $any($event)"
                  >
                  </ngx-mat-select-search>
                </mat-option>
                @for (value of filteredTicketStatus; track value) {
                  <mat-option
                    [value]="value.statusCode"
                    (click)="ticketRemarkClick()"
                  >
                    {{ value.status }}</mat-option
                  >
                }
              </mat-select>
              @if (
                myActivationsDetailsForm.controls['remarkbyaccolade'].touched &&
                myActivationsDetailsForm.controls['remarkbyaccolade'].errors
                  ?.required
              ) {
                <mat-error> This field is mandatory. </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="component-separator"></div>
      <div class="component-footer">
        <div class="button-group">
          <!-- @if (
            ticketDetails.certificateSentToCustomer &&
            ticketDetails.remarkbyaccolade === 'STS_CO_18'
          ) {
            <button
              type="button"
              class="edit-button"
              (click)="resendCertificates()"
              matTooltip="Resend Certificates via Email"
            >
              Resend Certificates
              <mat-icon class="btn-icon">forward_to_inbox</mat-icon>
            </button>
          } -->
          <button
            type="button"
            class="edit-button"
            (click)="openDeviceStatusHistoryPopUp()"
          >
            View History <mat-icon class="btn-icon">history</mat-icon>
          </button>
          @if (updateButtonVisible && MyActivationsUpdate) {
            <button
              type="button"
              class="edit-button"
              (click)="ticketAddAndUploadCertificates()"
            >
              Update Ticket <mat-icon class="btn-icon">edit</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>
  </form>
  <!-- Generate Backend Certificates -->
  <div class="custom-container">
    <!-- Generate Backend Certificates -->
    <div class="custom-modal custom-modal-m" id="generateBackendCertificates">
      <div class="custom-modal-dialog">
        <div class="custom-modal-content">
          <!-- Modal Header -->
          <div class="custom-modal-header">
            <h4 class="custom-modal-title">Backend Certificates Links</h4>
            <button
              type="button"
              class="custom-close-btn"
              (click)="closeModal()"
            >
              &times;
            </button>
          </div>
          <!-- Modal Body -->
          <div class="custom-modal-body">
            <div class="component-container">
              <div class="links-grid">
                <button
                  class="link-card"
                  (click)="openExternal('https://www.vltsecurity.com/#!#login')"
                >
                  <div class="link-card-content">
                    <div class="link-title">BSNL</div>
                    <div class="link-subtitle">
                      Vehicle Location Tracking Portal
                    </div>
                  </div>
                  <mat-icon>open_in_new</mat-icon>
                </button>

                <button
                  class="link-card"
                  (click)="openExternal('https://tracking.keralamvd.gov.in/')"
                >
                  <div class="link-card-content">
                    <div class="link-title">CDAC</div>
                    <div class="link-subtitle">
                      Kerala Vehicle Tracking System
                    </div>
                  </div>
                  <mat-icon>open_in_new</mat-icon>
                </button>

                <button
                  class="link-card"
                  (click)="openExternal('http://psv.autotrac.in/psv/')"
                >
                  <div class="link-card-content">
                    <div class="link-title">DIMS</div>
                    <div class="link-subtitle">
                      Public Service Vehicle Portal
                    </div>
                  </div>
                  <mat-icon>open_in_new</mat-icon>
                </button>

                <button
                  class="link-card"
                  (click)="openExternal('https://vlt.uk.gov.in/')"
                >
                  <div class="link-card-content">
                    <div class="link-title">NIC</div>
                    <div class="link-subtitle">
                      Government Tracking Platform
                    </div>
                  </div>
                  <mat-icon>open_in_new</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Ticket History -->
  <div class="custom-container">
    <div class="custom-modal custom-modal-xxl" id="ticketHistory">
      <div class="custom-modal-dialog">
        <div class="custom-modal-content">
          <!-- Modal Header -->
          <div class="custom-modal-header">
            <h4 class="custom-modal-title">Ticket History</h4>
            <button
              type="button"
              class="custom-close-btn"
              (click)="closeModal()"
            >
              &times;
            </button>
          </div>
          <!-- Modal Body -->
          <div class="custom-modal-body">
            <div class="component-container">
              <div class="component-header">
                <h6 class="component-title">Ticket History</h6>
                <div class="component-actions">
                  <!-- Total Production Devices -->
                  <button
                    type="button"
                    class="primary-button"
                    (click)="DownloadOutputReport()"
                  >
                    Download Report<mat-icon class="btn-icon"
                      >download</mat-icon
                    >
                  </button>
                </div>
              </div>
              <!-- Separator between Header and Body -->
              <div class="component-separator"></div>
              <!-- Component Body Section -->
              <div class="component-body">
                <table>
                  <thead>
                    <tr>
                      <th>Ticket No</th>
                      <th>Stage</th>
                      <th>Activity</th>
                      <th>Associated Activity</th>
                      <th>Associated Activity Status</th>
                      <th>Associated Activity Remark</th>
                      <th>Overall Ticket Status</th>
                      <th>Changed By</th>
                      <th>Date & Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (
                      item of ticketHistoryData
                        | paginate
                          : {
                              id: 'batchPaginate',
                              itemsPerPage: size,
                              currentPage: page,
                              totalItems: this.ticketHistoryData.length,
                            };
                      track item
                    ) {
                      <tr>
                        <td>{{ item.ticketNo ? item.ticketNo : '--' }}</td>
                        <td>{{ item.stage ? item.stage : '--' }}</td>
                        <td>{{ item.activity ? item.activity : '--' }}</td>
                        <td>{{ item.associated ? item.associated : '--' }}</td>
                        <!-- <td>{{item.status ? item.status : '--'}}</td> -->
                        <td>
                          {{
                            item.status
                              ? simplifiedTicketStatus[item.status]
                              : '--'
                          }}
                        </td>
                        <td>{{ item.remark ? item.remark : '--' }}</td>
                        <td>
                          {{
                            item.overAllStatus
                              ? simplifiedTicketStatus[item.overAllStatus]
                              : '--'
                          }}
                        </td>
                        <td>{{ getChangedByLabel(item) }}</td>
                        <td>{{ item.timeStamp | date: 'M/d/yy, h:mm a' }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              <!-- Separator between Header and Body -->
              <div class="component-separator"></div>
              <!-- Component Footer Section -->
              <div class="component-footer">
                @if (ticketHistoryData.length > 0) {
                  <app-common-component-pagination
                    [totalItems]="ticketHistoryData.length"
                    [pageSize]="size"
                    [currentPage]="page"
                    (pageChange)="onPageChange($event)"
                    (sizeChange)="onSizeChange($event)"
                  >
                  </app-common-component-pagination>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
